{
  "new-assignment": "New Assignment",
  "blank": "Blank",
  "use-curation": "Use template",
  "collegial": "Collegial",
  "set-up-your-assignment": "Set up your assignment",
  "change-the-dates-later": "You can easily change the dates later",
  "starts-at": "Starts at",
  "enter-start-date": "Enter start date",
  "ends-at": "Ends at",
  "enter-end-date": "Enter end date",
  "back": "Back",
  "next": "Next",
  "space": "Space",
  "choose-space": "Choose space",
  "set-up-your-assignment-succeed": "Set your assignment up to succeed",
  "choose-learning-items": "Choose learning items that provide context, clarity and community to ensure an engaging assignment",
  "get-started": "Get started",
  "short-introduction-to-purpose": "Short introduction to purpose, practical information and expectations for clarity",
  "kick-off-webinar": "Kick-off webinar",
  "live-session": "Live session on the Why, What and How for the initiative to take off",
  "manager-check-in": "Manager check-in",
  "exercise-manager-support": "Exercise where the learner has a conversation with their manager for support",
  "teams-channel": "Teams channel",
  "link-teams-channel": "Link to MS Teams channel with start-up exercise for peer interaction",
  "expert-webinar": "Expert webinar",
  "live-session-implementation": "Live session with internal examples and experts for context and implementation",
  "customize": "It’s time to customize!",
  "tailor-initiative": "You're done setting up your assignment. Now tailor it to your initiative!",
  "create": "Create",
  "creating": "Creating",
  "remove-learning-items": "Remove the learning items that are not relevant for your learners",
  "add-learning-items": "Add any other learning items that are relevant to the assignment",
  "adjust-text-times-images-add-links": "Adjust text, times, images and add links to learning items you have chosen",
  "add-learners-publish-assignment": "Add learners and publish your assignment",
  "error-on-creation": "Unable to create assignment. Try again.",
  "assignment-created": "Assignment created",
  "try-again": "Try again",
  "remove-assignment": "Remove assignment",
  "remove-assignment-message": "You will lose all progress data for <1/> <0>‘{{title}}‘</0>. This cannot be undone. <1 /><1 /> Are you sure you want to <2>permanently remove</2> it?"
}
